import React, { useEffect } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';

/**
 * LegacyPortalRedirect
 * 
 * Redirects old portal URLs to new team-specific portal format
 * Old: /portal/login, /client/:clientId
 * New: /portal/:team_id/login, /portal/:team_id/dashboard
 */
const LegacyPortalRedirect = () => {
  const navigate = useNavigate();
  const { clientId } = useParams();
  const location = useLocation();

  useEffect(() => {
    // Try to get team_id from localStorage or URL
    const storedTeamId = localStorage.getItem('portal_team_id');
    
    // Determine the new path based on current location
    let newPath = '/';
    
    if (location.pathname.includes('/portal/login')) {
      // Redirect old portal login to team-specific login
      if (storedTeamId) {
        newPath = `/portal/${storedTeamId}/login`;
      } else {
        // If no team_id available, redirect to main login
        newPath = '/login';
      }
    } else if (location.pathname.includes('/portal/forgot-password')) {
      if (storedTeamId) {
        newPath = `/portal/${storedTeamId}/forgot-password`;
      } else {
        newPath = '/login';
      }
    } else if (location.pathname.includes('/portal/reset-password')) {
      if (storedTeamId) {
        newPath = `/portal/${storedTeamId}/reset-password`;
      } else {
        newPath = '/login';
      }
    } else if (location.pathname.startsWith('/client')) {
      // Old /client or /client/:clientId routes
      if (storedTeamId) {
        newPath = `/portal/${storedTeamId}/dashboard`;
      } else {
        newPath = '/login';
      }
    }

    // Preserve query parameters if any
    const search = location.search;
    navigate(newPath + search, { replace: true });
  }, [navigate, location, clientId]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 flex items-center justify-center">
      <div className="text-center">
        <div className="inline-block animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-white"></div>
        <p className="mt-4 text-white text-lg">Redirecting...</p>
      </div>
    </div>
  );
};

export default LegacyPortalRedirect;
